<template>
  <div class="contenido centrar padeo navMargin">
    <vs-row align="center" justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
        <iframe src="https://discord.com/widget?id=696528472499159100&theme=dark" width="500" height="350" allowtransparency="true" frameborder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" w="6" direction="column" style="text-align: left;">
        <h1 style="margin: 0; margin-block-end: 0;">Comunidad</h1>
        <p style="margin: 0; margin-block-end: 0;">Únase con nosotros y comparta con la comunidad en Discord</p>
      </vs-col>
    </vs-row>
    <ul class="centrar">
      <li><vs-button href="https://discord.gg/abGp7bQ">Unirse ahora</vs-button></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CommunityMin"
}
</script>

<style scoped>
.contenido {
  padding-top: 10px;
}
.padeo {
  padding-top: 50px !important;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
